var _rect, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideochamadaEncerrada = function SvgVideochamadaEncerrada(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 390,
    viewBox: "0 0 528 390",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ilustra\xC3\xA7\xC3\xA3o no tamanho certo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2950_16388",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 528,
    height: 390
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 334",
    x: 528,
    y: 0.580078,
    width: 389,
    height: 528,
    transform: "rotate(90 528 0.580078)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2950_16388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.155 9.73126C359.782 10.1884 465.027 14.8858 492.964 97.7284C521.382 181.996 446.1 256.911 372.351 306.844C307.455 350.782 226.027 365.514 160.141 323.068C80.873 272.001 12.4269 184.042 44.1199 95.3867C74.2792 11.0219 182.358 9.26277 272.155 9.73126Z",
    fill: "url(#paint0_linear_2950_16388)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Object / Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M303.186 99.4843H300.693V101.977V206.495C300.693 213.695 294.856 219.533 287.655 219.533H234.902H232.41V222.025V251.875C232.41 258.757 237.989 264.336 244.871 264.336H493.241C500.123 264.336 505.702 258.757 505.702 251.875V111.946C505.702 105.063 500.123 99.4843 493.241 99.4843H303.186Z",
    stroke: "#498FFF",
    strokeWidth: 4.98458
  }), /*#__PURE__*/React.createElement("path", {
    id: "Header",
    d: "M300.98 101.949H493.654C499.16 101.949 503.623 106.413 503.623 111.918V132.937H300.98V101.949Z",
    fill: "#84AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Background",
    d: "M300.977 113.918H461.961V124.482H300.977V113.918Z",
    fill: "#C5D4FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Object / Calendar_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M285.356 51.8964H36.9867C30.1045 51.8964 24.5253 57.4755 24.5253 64.3578V204.287C24.5253 211.169 30.1045 216.748 36.9867 216.748H285.356C292.238 216.748 297.817 211.169 297.817 204.287V64.3578C297.817 57.4756 292.238 51.8964 285.356 51.8964Z",
    stroke: "#498FFF",
    strokeWidth: 4.98458
  }), /*#__PURE__*/React.createElement("path", {
    id: "Header_2",
    d: "M26.541 63.7719C26.541 58.2661 31.0044 53.8027 36.5102 53.8027H285.398C290.903 53.8027 295.367 58.2661 295.367 63.7719V84.6326H26.541V63.7719Z",
    fill: "#84AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4013 73.4521C50.4826 73.4521 52.1698 71.6523 52.1698 69.4321C52.1698 67.2119 50.4826 65.4121 48.4013 65.4121C46.32 65.4121 44.6328 67.2119 44.6328 69.4321C44.6328 71.6523 46.32 73.4521 48.4013 73.4521Z",
    fill: "#C5D4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 90.4785,
    y: 65.4121,
    width: 163.301,
    height: 10.72,
    fill: "#C5D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval Copy 47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1789 73.1324C60.27 73.1324 61.9651 71.332 61.9651 69.1111C61.9651 66.8902 60.27 65.0898 58.1789 65.0898C56.0878 65.0898 54.3926 66.8902 54.3926 69.1111C54.3926 71.332 56.0878 73.1324 58.1789 73.1324Z",
    fill: "#498FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Circle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1886 73.2379C70.2797 73.2379 71.9749 71.4375 71.9749 69.2166C71.9749 66.9957 70.2797 65.1953 68.1886 65.1953C66.0975 65.1953 64.4023 66.9957 64.4023 69.2166C64.4023 71.4375 66.0975 73.2379 68.1886 73.2379Z",
    fill: "#498FFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shadow",
    x: 443.756,
    y: 300.652,
    width: 69.2034,
    height: 3.3112,
    fill: "url(#paint1_radial_2950_16388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leaves",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.533 199.083C465.533 199.083 461.815 173.235 454.034 162.867C446.253 152.5 433.43 148.052 428.186 152.85C422.943 157.648 421.087 169.359 435.817 179.453C450.546 189.547 465.533 199.083 465.533 199.083ZM477.225 204.64C477.225 204.64 471.235 178.481 482.717 164.722C494.198 150.962 503.506 150.962 509.222 155.42C514.938 159.877 517.274 173.18 503.506 182.859C489.738 192.537 477.225 204.64 477.225 204.64ZM491.676 211.582C486.174 216.953 484.81 230.574 484.81 230.574C484.81 230.574 495.291 228.311 503.001 224.137C510.71 219.963 508.866 213.237 505.934 210.365C503.001 207.492 497.178 206.211 491.676 211.582Z",
    fill: "#9BE1D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.857 177.052C446.709 177.203 446.712 177.445 446.863 177.592C454.629 185.182 460.632 192.203 465.129 199.551C467.333 203.152 469.105 208.791 470.516 215.263C471.925 221.724 472.967 228.976 473.73 235.778C474.493 242.579 474.977 248.924 475.27 253.569C475.416 255.892 475.515 257.789 475.577 259.105C475.598 259.551 475.615 259.93 475.628 260.236C475.612 260.311 475.598 260.383 475.583 260.452C475.511 260.804 475.455 261.08 475.417 261.268L475.373 261.482L475.359 261.554L475.359 261.555C475.359 261.555 475.359 261.555 475.592 261.601L475.359 261.555C475.331 261.693 475.421 261.827 475.56 261.855C475.698 261.882 475.832 261.792 475.86 261.654L475.633 261.609L475.838 261.65C475.86 261.654 475.86 261.654 475.86 261.654L475.874 261.582L475.891 261.496L475.892 261.491C475.944 261.514 476.001 261.526 476.06 261.524C476.082 261.523 476.103 261.52 476.124 261.516C476.149 261.521 476.174 261.524 476.2 261.524C476.412 261.524 476.583 261.353 476.583 261.142C476.583 260.259 476.58 259.277 476.575 258.212C476.617 258.017 476.661 257.815 476.705 257.606C477.236 255.144 477.982 251.806 478.842 248.304C479.703 244.801 480.678 241.136 481.667 238.02C482.66 234.892 483.657 232.35 484.552 231.066C486.382 228.444 488.517 226.173 490.335 224.379C491.008 223.714 491.637 223.116 492.19 222.59L492.19 222.59L492.191 222.589C492.384 222.405 492.568 222.23 492.741 222.064C493.406 221.428 493.93 220.911 494.213 220.543C494.299 220.432 494.278 220.272 494.166 220.186C494.054 220.101 493.894 220.122 493.808 220.233C493.553 220.564 493.061 221.052 492.388 221.697C492.216 221.861 492.033 222.036 491.84 222.219L491.84 222.219C491.286 222.746 490.653 223.348 489.975 224.017C488.149 225.82 485.988 228.116 484.133 230.775C483.187 232.132 482.171 234.746 481.18 237.866C480.187 240.998 479.208 244.674 478.346 248.182C477.662 250.966 477.051 253.645 476.562 255.865C476.552 254.183 476.538 252.352 476.523 250.413L476.523 250.412C476.477 244.376 476.423 237.3 476.432 230.475C476.439 224.677 476.492 219.082 476.633 214.505C476.775 209.915 477.005 206.384 477.359 204.691C477.42 204.396 477.482 204.096 477.545 203.793L477.545 203.792C478.948 196.994 480.768 188.18 491.217 177.588C491.366 177.437 491.364 177.195 491.213 177.047C491.062 176.899 490.819 176.901 490.671 177.052C480.064 187.804 478.207 196.796 476.794 203.639L476.794 203.641L476.793 203.646C476.731 203.947 476.67 204.243 476.609 204.535C476.238 206.306 476.008 209.907 475.867 214.482C475.726 219.07 475.673 224.673 475.666 230.474C475.658 236.872 475.705 243.538 475.749 249.342C475.455 245.352 475.047 240.644 474.492 235.693C473.727 228.877 472.681 221.597 471.264 215.1C469.85 208.614 468.058 202.87 465.783 199.153C461.241 191.732 455.191 184.661 447.399 177.047C447.248 176.899 447.006 176.901 446.857 177.052Z",
    fill: "#696979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vase",
    d: "M496.867 265.475C496.867 262.114 494.142 259.389 490.781 259.389H464.399C461.037 259.389 458.312 262.114 458.312 265.475V282.717C458.312 293.364 466.943 301.994 477.59 301.994V301.994C488.236 301.994 496.867 293.364 496.867 282.717V265.475Z",
    fill: "#D3D4DD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lower body"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lower body/Pose 04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TESTE - LOWER / POSE 4 / MECH:FALSE",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.598 201.263L336.482 191.523C301.81 233.514 294.618 290.023 306.746 310.326C320.796 333.846 360.111 359.604 360.111 359.604L366.683 352.6C366.683 352.6 343.761 321.963 340.138 303.432C370.887 335.977 433.745 351.63 433.745 351.63L437.969 343.003C328.709 283.087 409.865 269.639 375.598 201.263Z",
    fill: "#997659"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shoe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sneakers",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.619 342.361C437.619 342.361 437.134 345.057 436.253 346.523C435.377 347.982 432.897 350.245 432.897 350.245C430.729 353.872 429.23 359.416 428.517 363.483C427.931 366.826 427.153 372.612 427.153 372.612C426.567 375.956 427.968 377.365 428.812 377.871L429.574 378.328C430.291 378.757 431.22 378.523 431.651 377.805L449.884 347.356C450.654 346.068 450.28 345.276 449.207 344.632L441.772 341.315C440.338 340.455 438.479 340.924 437.619 342.361Z",
    fill: "#D3D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10",
    d: "M448.799 344.444L428.812 377.871L430.892 379.119L450.904 345.65L449.24 344.652L448.799 344.444Z",
    fill: "#AAAAB9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shoe_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sneakers_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.345 351.663C366.345 351.663 365.163 354.133 363.925 355.313C362.694 356.486 359.705 358.006 359.705 358.006C356.654 360.925 353.738 365.873 351.972 369.605C350.52 372.674 348.234 378.048 348.234 378.048C346.782 381.117 347.757 382.851 348.436 383.565L349.048 384.209C349.625 384.815 350.582 384.838 351.187 384.26L376.831 359.76C377.914 358.724 377.765 357.859 376.902 356.951L370.623 351.763C369.47 350.551 367.556 350.506 366.345 351.663Z",
    fill: "#D3D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10_2",
    d: "M376.559 356.663L348.435 383.566L350.107 385.326L378.265 358.389L376.928 356.981L376.559 356.663Z",
    fill: "#AAAAB9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Back pants",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.067 293.887C304.513 326.543 351.605 354.767 351.605 354.767L362.687 343.453C362.687 343.453 336.336 312.922 341.092 274.376C344.091 250.075 366.518 197.503 366.518 197.503L334.78 189.599C310.015 218.343 295.029 256.876 300.067 293.887Z",
    fill: "#C762FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Front pants",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.453 200.568L342.135 191.773C342.135 191.773 332.468 247.652 340.179 296.453C345.688 331.322 418.682 349.355 418.682 349.355L428.61 333.841C428.61 333.841 385.041 305.383 382.307 295.351C379.572 285.32 384.811 280.097 386.787 258.201C388.664 237.399 383.268 221.377 377.453 200.568Z",
    fill: "#D28FFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Upper body"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TESTE - UPPER / POSE 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TESTE - UPPER / POSE 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.878 129.026C383.878 129.026 399.365 131.915 403.729 139.5C416.424 161.566 427.162 206.423 434.307 232.837C436.437 240.712 439.794 245.44 440.85 249.325C442.463 255.258 440.59 262.741 435.729 262.914C433.992 262.975 431.845 257.799 431.605 256.01C430.144 257.72 428.359 259.35 426.983 257.97C426.158 257.142 428.2 257.236 425.781 247.647C421.332 230.008 390.551 169.747 390.551 169.747L377.305 200.668L336.156 190.421L338.957 154.696C312.792 149.218 299.248 133.165 301.367 106.144C301.658 102.426 304.493 93.9422 305.408 89.1609C306.996 80.8688 311.488 71.4009 317.079 71.837C320.225 72.0824 322.788 74.9436 319.575 81.8501C320.71 81.4414 322.589 79.2803 324.379 80.3551C325.841 81.2324 320.717 85.2122 316.006 97.4681C309.737 113.778 316.422 139.54 348.161 127.243C355.162 124.53 365.086 124.346 365.086 124.346L383.878 129.026Z",
    fill: "#997659"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Front tshirt",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.932 190.064C334.932 190.064 355.504 197.261 377.701 200.714C392.876 177.249 393.88 139.339 383.302 128.83C383.302 128.83 377.049 131.844 371.875 130.478C366.868 129.155 363.293 124.884 363.293 124.884C344.544 131.547 334.121 171.812 334.932 190.064Z",
    fill: "#AAAAB9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.83 98.0796L301.168 95.3774C294.507 111.967 293.522 127.797 299.716 137.809C305.676 147.442 316.026 153.394 323.479 157.679C328.602 160.625 332.355 162.784 332.373 164.809C332.443 172.647 283.97 269.667 283.97 269.667L320.259 278.703L365.173 132.268L363.806 123.978C356.507 122.16 348.238 123.256 340.587 124.269C331.851 125.427 323.921 126.477 319.16 122.963C314.765 119.718 315.474 110.388 317.83 98.0796ZM386.558 293.482L339.781 281.834C343.114 265.193 373.028 133.876 373.028 133.876L383.244 128.816C383.244 128.816 398.803 131.502 405.188 140.156C421.123 161.753 434.738 205.507 439.474 240.215L422.696 243.987C414.855 229.936 396.151 197.399 395.853 198.589C390.199 221.178 388.728 250.616 387.333 278.521C387.08 283.575 386.83 288.579 386.558 293.482Z",
    fill: "#F0F0F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Head shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.457 95.7676C361.894 98.2365 357.267 98.8997 356.746 100.982C356.224 103.064 357.384 104.189 358.685 105.336C357.782 108.944 357.518 112.037 360.033 115.35C362.104 118.078 365.459 118.637 365.813 120.384C366.166 122.132 363.732 123.876 363.732 123.876C363.732 123.876 366.287 129.697 371.795 131.069C377.303 132.44 383.709 128.851 383.709 128.851C382.463 123.701 384.839 114.208 384.839 114.208C385.801 113.486 386.55 112.913 386.55 112.913C386.55 112.913 389.196 110.834 390.562 108.429C391.928 106.024 392.22 102.772 392.27 101.042C392.33 98.9658 391.926 96.7665 391.077 94.8294C390.216 92.8672 389.016 90.9367 386.196 88.7865C380.592 84.5137 375.191 85.2061 373.318 85.5796C371.444 85.9531 369.53 86.7184 367.541 88.0664C365.552 89.4145 363.357 91.8181 362.457 95.7676Z",
    fill: "#997659"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Body / Eye Adult"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Eye",
    width: 2.67122,
    height: 5.36662,
    rx: 1.33561,
    transform: "matrix(0.970366 0.241641 -0.242812 0.970073 365.57 95.4355)",
    fill: "#24252E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hair / Front buns"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Short hair",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.384 89.5833C365.749 90.7266 376.03 90.6725 377.019 92.873C377.772 94.5475 377.547 99.4067 377.277 102.776C378.397 102.502 382.481 102.137 383.319 105.94C384.157 109.744 381.561 111.862 378.879 112.024L380.388 116.548L383.561 119.274C383.561 119.274 390.975 114.545 393.351 110.311C395.727 106.077 400.359 93.6978 392.623 88.5155C384.887 83.3331 367.13 81.7486 365.434 82.8127C363.739 83.8768 364.175 85.7955 365.384 89.5833Z",
    fill: "#24252E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Accessories / Glasses"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.995 94.0167L362.995 94.0167C363.12 93.6461 363.186 93.4512 363.552 92.7208C363.49 92.7398 363.407 92.7619 363.307 92.7881C362.776 92.9281 361.803 93.1843 361.409 93.7039C360.93 94.3341 360.458 95.2603 360.13 96.5696L359.65 98.4891C359.65 98.4891 360.512 98.0472 360.95 97.6972L360.992 97.5278C361.129 97.5034 361.317 97.4736 361.484 97.4598C361.573 97.4525 361.672 97.4739 361.77 97.5086C361.711 97.6834 361.659 97.8625 361.613 98.0454C360.857 101.064 362.218 104.003 364.651 104.609C367.085 105.215 369.67 103.259 370.426 100.24C370.539 99.7909 370.604 99.3436 370.626 98.9055C372.625 99.4097 376.44 100.387 376.44 100.387C376.44 100.387 378.195 100.791 378.788 100.938C379.815 101.194 380.233 101.483 380.388 101.675C380.495 101.807 380.473 101.906 380.434 102.085C380.433 102.09 380.432 102.094 380.431 102.099C380.991 102.04 381.529 102.091 381.529 102.091C381.574 101.909 381.561 101.421 381.22 100.999C380.841 100.528 380.137 100.168 379.049 99.8972C378.411 99.7384 376.592 99.3203 376.592 99.3203C376.592 99.3203 372.685 98.3217 370.589 97.7924C370.344 95.7692 369.146 94.1142 367.388 93.6764C365.372 93.1744 363.252 94.4306 362.154 96.5927C361.839 96.4469 361.497 96.4255 361.249 96.5235C361.736 94.8112 362.28 94.6581 362.648 94.5543C362.714 94.5356 362.775 94.5184 362.829 94.494C362.901 94.2943 362.951 94.145 362.995 94.0167ZM362.65 98.3036C361.984 100.964 363.245 103.153 364.912 103.568C366.579 103.983 368.723 102.642 369.389 99.9818C370.055 97.3216 368.794 95.1327 367.127 94.7176C365.46 94.3025 363.316 95.6434 362.65 98.3036Z",
    fill: "#24252E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 5",
    opacity: 0.1,
    cx: 3.47259,
    cy: 4.56162,
    rx: 3.47259,
    ry: 4.56162,
    transform: "matrix(-0.970366 -0.241641 -0.242812 0.970073 370.496 95.5586)",
    fill: "#24252E"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Body_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lower body_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lower body/Pose 04_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TESTE - LOWER / POSE 4 / MECH:FALSE_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.392 169.274L180.997 169.274C204.607 218.392 197.813 274.956 180.997 291.724C161.515 311.149 117.429 326.266 117.429 326.266L112.72 317.882C112.72 317.882 141.981 294.071 150.053 276.968C112.047 301.114 46.7975 301.114 46.7975 301.114L44.7791 291.724C166.198 259.989 90.1851 227.334 140.392 169.274Z",
    fill: "#FFC89C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shoe_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sneakers_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.276 291.19C45.276 291.19 45.0905 293.923 45.5922 295.558C46.0914 297.186 47.9611 299.98 47.9611 299.98C49.193 304.023 49.3019 309.764 49.004 313.882C48.759 317.267 48.1037 323.069 48.1037 323.069C47.8587 326.455 46.1452 327.484 45.196 327.771L44.3399 328.03C43.5342 328.273 42.6835 327.822 42.4388 327.02L32.0691 293.074C31.6316 291.638 32.1908 290.959 33.3972 290.594L41.4737 289.172C43.085 288.685 44.7865 289.588 45.276 291.19Z",
    fill: "#D3D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10_3",
    d: "M33.8404 290.51L45.1952 327.77L42.8579 328.478L31.4888 291.171L33.3587 290.605L33.8404 290.51Z",
    fill: "#AAAAB9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shoe_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sneakers_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.645 317.43C112.645 317.43 113.197 320.113 114.117 321.556C115.033 322.992 117.582 325.189 117.582 325.189C119.85 328.758 121.489 334.263 122.302 338.311C122.971 341.639 123.889 347.405 123.889 347.405C124.558 350.733 123.181 352.18 122.343 352.709L121.587 353.186C120.875 353.635 119.935 353.426 119.485 352.718L100.419 322.753C99.6138 321.485 99.9715 320.683 101.037 320.01L108.441 316.494C109.864 315.596 111.745 316.015 112.645 317.43Z",
    fill: "#D3D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10_4",
    d: "M101.444 319.813L122.345 352.71L120.281 354.014L99.3543 321.075L101.005 320.032L101.444 319.813Z",
    fill: "#AAAAB9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Back pants_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.541 277.384C179.21 307.993 126.291 323.999 126.291 323.999L118.23 310.345C118.23 310.345 151.446 287.089 156.226 248.542C159.239 224.24 150.183 167.815 150.183 167.815L183.128 167.815C200.297 201.687 205.517 242.693 191.541 277.384Z",
    fill: "#36A094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Front pants_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.748 168.149L175.411 168.149C175.411 168.149 171.189 224.7 151.719 270.185C137.807 302.684 62.07 302.544 62.07 302.544L56.1634 285.094C56.1634 285.094 105.697 268.009 110.823 258.937C115.948 249.865 112.107 243.532 115.532 221.811C118.785 201.175 127.976 186.933 138.748 168.149Z",
    fill: "#9BE1D8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Upper body_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TESTE - UPPER / POSE 8_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TESTE - UPPER / POSE 3_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.967 97.1857C149.967 97.1857 134.128 96.247 128.009 102.551C110.206 120.894 88.7422 161.82 75.3004 185.721C71.2928 192.848 66.8565 196.623 64.8739 200.138C61.847 205.504 61.8469 213.217 66.5546 214.559C68.2373 215.038 71.6007 210.534 72.2731 208.857C73.2824 210.87 74.6277 212.882 76.3094 211.876C77.3187 211.272 75.3004 210.87 80.0091 202.15C88.6704 186.112 133.487 135.082 133.487 135.082L138.868 168.283L181.583 168.283L186.292 132.73C225.838 133.4 228.971 97.2562 229.445 90.4662C230.527 74.9522 233.832 72.0308 233.412 68.0972C232.513 59.657 230.156 58.2782 227.129 58.0157C224.784 57.8123 223.43 63.0461 222.421 64.723C221.412 64.0522 220.066 60.6986 217.712 62.3754C216.316 63.3693 219.169 63.0566 219.705 81.0856C220.242 99.1238 212.617 122.151 184.611 102.551C178.434 98.2285 169.475 97.1857 169.475 97.1857L149.967 97.1857Z",
    fill: "#FFC89C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Front tshirt_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.866 168.234C182.866 168.234 161.004 170.246 138.469 168.234C129.38 141.801 137.671 104.777 150.577 97.1367C150.577 97.1367 155.951 101.572 161.34 101.496C166.556 101.423 171.094 98.1428 171.094 98.1428C187.785 109.137 188.122 150.722 182.866 168.234Z",
    fill: "#AAAAB9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.536 101.068C199.89 106.035 212.511 110.729 218.99 81.4414L231.975 83.9669C227.473 123.964 208.887 133.581 198.518 138.946C194.764 140.888 192.087 142.274 191.546 144.341C189.561 151.929 213.196 257.77 213.196 257.77H175.527L167.454 104.845L170.818 97.1312C175.953 97.1312 181.301 99.1204 186.536 101.068ZM107.124 256.093H155.682C156.494 239.142 159.381 104.508 159.381 104.508L150.636 97.1305C150.636 97.1305 134.777 95.9779 126.42 102.832C105.567 119.935 81.5625 159.096 68.4453 191.627L83.9169 199.34C95.0161 187.602 121.25 160.553 121.25 161.779C121.25 185.062 115.488 213.979 110.026 241.389C109.037 246.354 108.058 251.269 107.124 256.093Z",
    fill: "#F0F0F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Head shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.029 70.0937C178.975 72.6251 183.334 74.3863 183.334 76.5326C183.334 78.679 181.926 79.4896 180.374 80.2887C180.374 84.0073 179.876 87.0716 176.607 89.6789C173.917 91.8252 170.501 91.5569 169.729 93.1666C168.956 94.7764 170.908 97.0569 170.908 97.0569C170.908 97.0569 166.987 102.087 161.27 102.087C155.552 102.087 150.17 97.0569 150.17 97.0569C152.648 92.3618 152.648 82.5774 152.648 82.5774C151.884 81.6448 151.292 80.9075 151.292 80.9075C151.292 80.9075 149.216 78.2516 148.469 75.5877C147.722 72.9239 148.233 69.6981 148.607 68.0076C149.056 65.979 149.988 63.9427 151.292 62.2686C152.613 60.5728 154.258 58.9897 157.539 57.5849C164.061 54.7934 169.168 56.7699 170.908 57.5849C172.647 58.4 174.33 59.6048 175.944 61.3934C177.558 63.182 179.115 66.0441 179.029 70.0937Z",
    fill: "#FFC89C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Body / Eye Adult_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Eye_2",
    width: 2.69071,
    height: 5.36581,
    rx: 1.34535,
    transform: "matrix(-1 0 0 1 176.072 69.0215)",
    fill: "#24252E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Accessories / Stethoscope"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Back part",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.508 133.857C164.727 133.857 168.289 130.652 168.824 126.374L172.281 98.7244V97.1782C172.281 96.5392 171.774 96.0211 171.149 96.0211H168.914V93.707H171.149C173.024 93.707 174.545 95.2611 174.545 97.1782V98.798C174.545 98.8471 174.542 98.8961 174.535 98.9447L171.069 126.667C170.434 131.752 166.43 135.643 161.527 136.121V165.443C161.527 172.089 166.798 177.477 173.3 177.477C179.802 177.477 185.073 172.089 185.073 165.443V148.319C185.073 140.779 191.053 134.666 198.431 134.666C205.808 134.666 211.788 140.779 211.788 148.319V162.088H209.751V148.319C209.751 141.929 204.683 136.748 198.431 136.748C192.179 136.748 187.111 141.929 187.111 148.319V165.443C187.111 173.239 180.927 179.559 173.3 179.559C165.673 179.559 159.489 173.239 159.489 165.443V136.121C154.586 135.644 150.582 131.752 149.946 126.667L146.48 98.9447C146.474 98.8961 146.471 98.8471 146.471 98.798V97.1782C146.471 95.2611 147.991 93.707 149.867 93.707H152.101V96.0211H149.867C149.242 96.0211 148.735 96.5392 148.735 97.1782V98.7244L152.192 126.374C152.727 130.652 156.288 133.857 160.508 133.857Z",
    fill: "#24252E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Front part",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.714 126.831L147.162 106.858L150.081 106.469L152.633 126.441C153.149 130.483 156.519 133.507 160.507 133.507C164.496 133.507 167.866 130.483 168.382 126.441L170.934 106.469L173.853 106.858L171.301 126.831C170.593 132.371 165.974 136.515 160.507 136.515C155.041 136.515 150.422 132.371 149.714 126.831ZM216.43 163.013C216.43 166.208 213.896 168.798 210.77 168.798C207.644 168.798 205.11 166.208 205.11 163.013C205.11 159.817 207.644 157.227 210.77 157.227C213.896 157.227 216.43 159.817 216.43 163.013Z",
    fill: "#498FFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hair / Front buns_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Curly hair",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.237 81.148C157.237 81.148 152.609 77.5264 156.429 73.0468C157.391 71.9198 161.273 71.4863 162.895 73.815C168.091 67.5809 173.381 60.7948 173.381 59.0094C170.892 56.9146 167.608 55.7832 162.895 56.2481C158.183 56.713 154.082 58.1758 151.317 61.7786C149.784 63.2158 149.434 63.3884 147.55 63.3884C145.667 63.3884 140.824 59.9006 133.828 63.925C128.446 67.681 129.791 74.12 129.791 74.12C126.024 74.12 121.181 78.9492 120.912 84.8516C120.912 91.8271 125.755 92.632 125.755 92.632C125.755 92.632 124.679 100.663 131.675 103.364C140.016 106.583 143.245 101.754 143.245 101.754C143.245 101.754 148.088 106.661 154.546 103.9C158.724 102.114 160.765 98.2383 160.735 93.7052C160.696 87.9251 155.622 85.9248 155.622 85.9248C155.622 85.9248 157.237 84.315 157.237 81.148Z",
    fill: "#5B3616"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2950_16388",
    x1: 267.654,
    y1: 348.371,
    x2: 267.79,
    y2: -251.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AF0",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AF0",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2950_16388",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(478.358 302.308) rotate(90) scale(1.6556 34.6017)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideochamadaEncerrada, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/videochamada-encerrada.f6880997.svg";
export { ForwardRef as ReactComponent };